<script setup>
defineProps({
  isLimited: {
    type: Boolean,
    default: true,
  },
})
</script>
<template>
  <div
    :class="{
      [$style.wrapper]: true,
      [$style.limited]: isLimited
    }"
  >
    <slot />
  </div>
</template>

<style module lang="scss">
.wrapper {
  width: 100%;
  margin: 0 auto;
  &.limited {
    max-width: 1024px;
  }
}
</style>
